/**
 * author: Patrick Vyn Badiang
 */
import React from "react";
import { Button, Typography } from "@mui/material";
// import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import AddAlertIcon from '@mui/icons-material/AddAlert';

const AddToCalendarButton = ({ eventLink, buttonText }) => {
  return (
    <Button
      href={eventLink}
      target="_blank"
      color="primary"
      sx={{
        margin: "10px",
        bgcolor: "#ffffff",
        borderRadius: "10px",
        color: "black",
        textTransform: "none",
        "&:hover": {
          bgcolor: "#f5f5f5",
        },
      }}
      startIcon={<AddAlertIcon />}
    >
      <Typography variant="body" align="center">
        {buttonText || "Add to Calendar"}
      </Typography>
    </Button>
  );
};

export default AddToCalendarButton;
